import forEach from "lodash/forEach";
import isArray from "lodash/isArray";

/**
 * Return message for HTTP status code
 * @param {number} status - HTTP status code
 * @returns {string} Message of network operation
 */
function _getStatusMessage(status) {
  let message = "";
  switch (status) {
    case 200:
      message = "Sucesso";
      break;
    case 201:
      message = "Atualização realizada com sucesso";
      break;
    case 400:
      message = "Erro de requisição";
      break;
    case 401:
      message = "Erro de Autorização";
      break;
    case 404:
      message = "Não encontrado";
      break;
    // case 422:
    //   message = 'Os dados são inválidos'
    //   break
    case 503:
      message = "Servidor indisponível. Tente mais tarde";
      break;
    default:
      message = "Alguma coisa saiu errao :( Tente mais tarde";
      break;
  }
  return message;
}

function _getResponseErrorMessage(error) {
  // console.log(error.response)
  if (error.response.data && error.response.data.errors) {
    if (error.response.data.errors.email) {
      if (error.response.data.errors.email instanceof Array)
        return error.response.data.errors.email[0];
      return error.response.data.errors.email;
    }
    if (error.response.data.errors.password)
      return error.response.data.errors.password[0];
  }
  if (error.response.data.message) return error.response.data.message;
  if (error.response.data.email) return error.response.data.email;
  if (error.response && error.response.data)
    return error.response.data.description;
  if (error.response && error.response.statusText)
    return error.response.statusText;
  if (error.message) return error.message;
  return null;
}

/**
 * Create instant, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
export class ResponseWrapper {
  constructor(response, data = {}, message) {
    this.data = data;
    this.meta = response.data.meta;
    this.success = response.data.success;
    this.status = response.status;
    this.headers = response.headers;
    this.statusMessage = _getStatusMessage(this.status);
    this.message = message || null;
  }

  isSuccess() {
    return this.status === 200;
  }

  isCreated() {
    return this.status === 201;
  }
}

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
export class ErrorWrapper extends Error {
  constructor(error, message) {
    super();
    this.name = "ErrorWrapper";
    this.stack = new Error().stack;
    this.success = error.response ? error.response.data.success : false;
    this.response = error.response;
    this.status = error.response ? error.response.status : false;
    this.statusMessage = _getStatusMessage(this.status);
    this.message = message || _getResponseErrorMessage(error);
    if (!this.message) this.message = this.statusMessage;
  }

  isValidationError() {
    return this.status === 422;
  }

  isForbiddenError() {
    return this.status === 403;
  }
}

/**
 * Uses to clear request data before send it
 * Client shouldn't change entity id
 * @param data
 * @return {{}}
 */
export function clearData(data) {
  let result = {};
  forEach(data, (item, propName) => {
    if (isArray(item) && item.length) {
      result[propName] = item;
    }
    if (!isArray(item) && item && propName !== "id") {
      result[propName] = item;
    }
  });
  return result;
}
